import styled from 'styled-components';
import type { SellerNotice } from '../../Page/Broadcast/sellerNotice';
import TransientSellerNotice from './TransientSellerNotice';

export default function SellerChatFeed({ messages, persistent = false }: { messages: SellerNotice[]; persistent?: boolean }) {
  if (!messages.length) return null;
  const recent = messages.slice(-3);
  const lines = recent.map(message => message.content);
  return <Feed aria-label="셀러 채팅">
    <TransientSellerNotice key={recent.map(message => `${message.seq}:${message.content}`).join('|')} className="seller-chat-latest" content={lines.join('\n')} lines={lines} persistent={persistent} plain />
  </Feed>;
}

const Feed = styled.section`
  min-width: 0; flex-shrink: 0; margin: 0 16px 12px; color: var(--color-warning, #ffcc00);
  &:empty { display: none; }
  .seller-chat-latest { margin: 0; padding: 0; border: 0; border-radius: 0; background: transparent; color: inherit; font-size: 14px; line-height: 1.5; }
  .seller-chat-latest strong { color: inherit; font-size: 12px; }
  .seller-chat-latest p { display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; overflow: hidden; margin: 4px 0 0; white-space: pre-wrap; overflow-wrap: anywhere; }
`;
